<template>
  <body class="report-accountant-voucher-offline">
    <div class="container-accountant-voucher">
      <!-- Header -->
      <div class="header-contain">
        <div class="header-info">
          <div class="d-flex">
            <div class="header-info-label">Đơn vị:</div>
            <div class="header-info-value">{{ model.CompanyName }}</div>
          </div>
          <div class="d-flex" style="margin-top: 4px">
            <div class="header-info-label">Địa chỉ:</div>
            <div class="header-info-value">{{ model.CompanyAdrress }}</div>
          </div>
        </div>
        <div class="header-title">
          <span class="">CHỨNG TỪ KẾ TOÁN</span>
        </div>
      </div>

      <!-- Body -->
      <div class="body-contain">
        <div class="body-content-block">
          <div class="body-content-row">
            <div class="d-flex w-bigger">
              <div class="content-label">Tên:</div>
              <div class="content-value">{{ model.accounting_object_name }}</div>
            </div>
            <div class="d-flex w-smaller">
              <div class="content-label">Số CT:</div>
              <div class="content-value">{{ model.ref_no }}</div>
            </div>
          </div>
          <div class="body-content-row">
            <div class="d-flex w-bigger">
              <div class="content-label">Địa chỉ:</div>
              <div class="content-value">{{ model.accounting_object_address }}</div>
            </div>
            <div class="d-flex w-smaller">
              <div class="content-label">Ngày:</div>
              <div class="content-value">{{ model.txtValueDate }}</div>
            </div>
          </div>
        </div>
        <div class="body-table-block">
          <ms-grid-viewer
            :columns="columnsReport"
            class="plr-20 bg-white pt-1"
            :filterable="false"
            :ref="viewRef"
            :data="model.dataDetail"
            idField=""
            :loading="loading"
            v-on="_gridEvent"
            :lockable="false"
            :footer="false"
            :queryMode="'local'"
            :lineBreak="0"
          >
          </ms-grid-viewer>
        </div>
        <div class="body-content-block">
          <div class="body-content-row">
            <div class="d-flex">
              <div class="content-label">Thành tiền bằng chữ:</div>
              <div class="content-value">{{ model.strTotalAmount }}</div>
            </div>
          </div>
          <div class="body-content-row">
            <div class="d-flex">
              <div class="content-label">Ghi chú:</div>
              <div class="content-value">{{ model.journal_memo }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-containx"></div>
      <div class="footer-contain">
        <div class="footer-block">
          <div class="footer-col">
            <div class="sign-label">
              <div class="sign-name">{{ model.CompanyChiefAccountantTitle }}</div>
              <div class="sign-sub">(Ký, họ tên)</div>
            </div>
            <div class="sign-value">{{ model.CompanyChiefAccountant }}</div>
          </div>
          <div class="footer-col">
            <div class="sign-label">
              <div class="sign-name">{{ model.CompanyDirectorTitle }}</div>
              <div class="sign-sub">(Ký, họ tên)</div>
            </div>
            <div class="sign-value">{{ model.CompanyDirector }}</div>
          </div>
        </div>
      </div>
    </div>
  </body>
</template>

<script>
import msDynamicPopup from '@/components/popup/MsDynamicPopup.vue';
import basePopup from '@/views/base/basePopup';
import msGridEditor from '@/components/gridEditor/MsGridEditor.vue';
import msGridViewer from '@/components/gridViewer/MsGridViewer.vue';
import {ModuleBankInfo} from '@/stores/moduleConst';
import {defineComponent, onMounted, computed, reactive, ref, getCurrentInstance, watch} from 'vue';
import {mapGetters} from 'vuex';
import {ModuleContext} from '@/stores/moduleConst';
import commonFunction from '../../../commons/commonFunction';

export default {
  components: {
    msDynamicPopup,
    msGridEditor,
    msGridViewer,
  },
  extends: basePopup,
  name: 'C4-O8/KS',
  props: {
    dataReport: {
      default: {},
      type: Object,
    },
  },
  computed: {
    /**
     * Số lượng cột shimmer
     */
    shimmerColumn() {
      let res = [];
      res.push({
        offset: undefined,
        lock: undefined,
      });
      res.push({
        offset: undefined,
        lock: undefined,
      });
      return res;
    },
    ...mapGetters({
      postedDate: ModuleContext + '/PostedDate',
    }),
  },

  setup(props) {
    const {proxy} = getCurrentInstance();
    const model = reactive({
      CompanyName: '.............................................................................................', // Đơn vị nhận tiền (Lấy từ dbOption và phải có dữ liệu chi tiết mới hiển thị)
      CompanyAdrress: '.............................................................................................', // Địa chỉ đơn vị nhận tiền (Lấy từ dbOption và phải có dữ liệu chi tiết mới hiển thị)
      accounting_object_name:
        '......................................................................................................', // Người nộp
      accounting_object_address:
        '...........................................................................................................', // Địa chỉ
      ref_no: '..............', // Số CT
      txtValueDate: ' ...... tháng ...... năm .......',
      dataDetail: [
        {
          description: '',
          amount: 0,
        },
      ],
      strTotalAmount: '...................................................................', // TỔng tiền bằng chữ
      journal_memo: '...................................................................',
      CompanyChiefAccountantTitle: 'Kế toán trưởng',
      CompanyDirectorTitle: 'Thử trưởng đơn vị',
      CompanyChiefAccountant: '',
      CompanyDirector: '',
    });
    onMounted(() => {
      dbOptions.value = {...proxy.$store.state.dbOption.dbOptions};
      genReportByRefType(proxy.dataReport);
    });

    const columnsReport = reactive([
      {
        title: 'STT',
        caption: 'STT',
        dataField: 'line',
        width: 50,
        sortable: false,
      },
      {
        title: 'Diễn giải',
        caption: 'Diễn giải',
        dataField: 'description',
        sortable: false,
      },
      {
        title: 'Ghi nợ',
        caption: 'Ghi nợ',
        dataField: 'debit_account',
        width: 75,
        sortable: false,
      },
      {
        title: 'Ghi có',
        caption: 'Ghi có',
        dataField: 'credit_account',
        width: 75,
        sortable: false,
      },
      {
        title: 'Thành tiền',
        caption: 'Thành tiền',
        dataField: 'amount',
        width: 100,
        sortable: false,
      },
    ]);
    const dbOptions = ref([]);

    /**
     * Xử lý đọc số
     */
    const numberText = input => {
      if (input == 0) {
        return '';
      } else {
        let readNumber = input || 0;
        let isNegative = readNumber < 0;
        let readText = read((isNegative ? -readNumber : readNumber).toString());
        let result;
        if (isNegative) {
          result = 'Âm ' + readText;
        } else {
          result = readText.charAt(0).toUpperCase() + readText.slice(1);
        }
        if (result != null) {
          result = result.trim();
        }
        if (result == '') {
          result += 'Không';
        }
        result += ` đồng`;
        if (dbOptions.value.SayMoney_Even) {
          result += ' chẵn';
        }
        return dbOptions.value.SayMoney_Prefix + result + dbOptions.value.SayMoney_Surfix;
      }
    };

    const roundValue = (toFix, value) => {
      const numberVal = Number(value);
      if (!isNaN(numberVal)) {
        return Number(numberVal.toFixed(toFix));
      }
    };

    const read = num => {
      // Đọc từng phần
      const output = [];

      let groupLength = num.length % 3;

      num = num.split('');
      for (let i = 0; i < 3 - groupLength && groupLength != 0; i++) {
        num.unshift('0');
      }
      num = num.join('');

      for (let i = 0; i < num.length / 3; i++) {
        let [a, b, c] = num.substr(i * 3, 3);
        a = parseInt(a);
        b = parseInt(b);
        c = parseInt(c);

        // Sửa lại ở đây
        const isFirstGroup = i == 0;
        // Nếu là rỗng thì sang bộ 3 tiếp theo
        if (a == 0 && b == 0 && c == 0) {
          continue;
        }

        output.push(...readThree(a, b, c, !isFirstGroup)); // Dùng spread operator

        // Đọc phần đơn vị của nhóm
        output.push(`${genUnits(num.length / 3 - 1 - i)}`);
      }
      return output.join(' ');
    };

    /**
     * giá trị đơn vị
     */
    const genUnits = index => {
      switch (index) {
        case 0:
          return '';
        default:
          let modIndex = index % 3;
          let res = '';
          switch (modIndex) {
            case 0:
              res = 'tỷ';
              break;
            case 1:
              res = `${dbOptions.value.SayMoney_Nghin}`;
              break;
            case 2:
              res = 'triệu';
              break;
          }
          if (dbOptions.value.SayMoney_ShowThousandSymbol) {
            res += ',';
          }
          return res;
      }
    };

    /**
     * Giá trị phần số
     */
    const genDigits = number => {
      switch (number) {
        case 0:
          return 'không';
        case 1:
          return 'một';
        case 2:
          return 'hai';
        case 3:
          return 'ba';
        case 4:
          return 'bốn';
        case 5:
          return 'năm';
        case 6:
          return 'sáu';
        case 7:
          return dbOptions.value.SayMoney_7;
        case 8:
          return 'tám';
        case 9:
          return 'chín';
      }
    };

    // Định nghĩa function đọc hai số cuối
    function readTwo(b, c, hasHundred) {
      const output = [];

      switch (b) {
        case 0: {
          // Nếu có đọc hàng trăm (đọc rồi) và b = 0, c = 0
          // thì không đọc nữa
          if (hasHundred && c == 0) break;
          if (hasHundred) output.push(dbOptions.value.SayMoney_Linh); // ví dụ a05 đọc là "a lẻ năm"
          output.push(genDigits(c));
          break;
        }

        case 1: {
          // Trường hợp số hàng chục là 10
          output.push('mười');
          if (c == 5) output.push('lăm');
          // Mười lăm
          else if (c != 0) output.push(genDigits(c));
          // Trường hợp c = 0 không xét vì đã đọc "mười" rồi
          break;
        }

        default: {
          output.push(genDigits(b), dbOptions.value.SayMoney_Muoi); // b mươi
          if (c == 1) output.push('mốt');
          // Chỗ này đọc "tư" hay "bốn" thì các bạn điều chỉnh nhe
          // Mình sẽ luôn đọc là "tư" nhé
          else if (c == 4) output.push(dbOptions.value.SayMoney_4);
          else if (c == 5) output.push('lăm');
          else if (c != 0) output.push(genDigits(c));
          // Không đọc c = 0 vì đã đọc "b mươi" rồi
          break;
        }
      }

      // Trả về mảng output, xem lại phần trước nhé
      return output;
    }

    // Định nghĩa function đọc 3 số
    function readThree(a, b, c, readZeroHundred) {
      const output = [];

      // Đọc phần trăm (a) trước
      if (a != 0 || readZeroHundred) output.push(genDigits(a), 'trăm'); // Đọc là "a trăm"

      // Nối thêm phần sau (b, c)
      // Ở đây dùng spread syntax để nối output
      output.push(...readTwo(b, c, a != 0 || readZeroHundred));

      return output;
    }
    /**
     * Case lấy dữ liệu báo cáo theo từng loại chứng từ
     */
    function genReportByRefType(data) {
      if (data?.dataVoucher?.ref_type) {
        switch (data.dataVoucher.ref_type) {
          case proxy.$ms.constant.RefType.BUTransferDeposit:
            genDataReport(data.dataVoucher, data?.dataParam);
            break;
          default:
            console.log(`Chưa khai báo hàm xử lý lấy dữ liệu cho loại chứng từ ${data.ref_type}`);
            break;
        }
      } else {
        console.log(`Chưa khai báo loại chứng từ`);
      }
    }

    /**
     * Gen dữ liệu in lên báo cáo
     */
    function genDataReport(data, dataParam) {
      proxy.model.txtValueDate = data.ref_date
        ? ` ${data.ref_date.getDate() > 9 ? `${data.ref_date.getDate()}` : `0${data.ref_date.getDate()}`}/${data.ref_date.getMonth() + 1 > 9 ? `${data.ref_date.getMonth() + 1}` : `0${data.ref_date.getMonth() + 1}`}/${data.ref_date.getFullYear()}`
        : '..............................';

      //Tên đơn vị
      proxy.model.CompanyName =
        dbOptions.value.CompanyName && dbOptions.value.CompanyName != ''
          ? dbOptions.value.CompanyNameFontTransform
            ? dbOptions.value.CompanyName
            : dbOptions.value.CompanyName.toUpperCase()
          : '...........................................................';
      //Địa chỉ đơn vị
      proxy.model.CompanyAdrress =
        dbOptions.value.CompanyAdrress && dbOptions.value.CompanyAdrress != ''
          ? dbOptions.value.CompanyNameFontTransform
            ? dbOptions.value.CompanyAdrress
            : dbOptions.value.CompanyAdrress.toUpperCase()
          : '...........................................................';

      // Số CT
      proxy.model.ref_no = data.ref_no || '..............................';
      // Tên
      proxy.model.accounting_object_name =
        data.accounting_object_name && data.accounting_object_name != ''
          ? data.accounting_object_name
          : '...........................................................';
      // Địa chỉ
      proxy.model.accounting_object_address =
        data.accounting_object_address && data.accounting_object_address != ''
          ? data.accounting_object_address
          : '...........................................................';
      // Ghi chú
      proxy.model.journal_memo =
        data.journal_memo && data.journal_memo != ''
          ? data.journal_memo
          : '...........................................................';

      // Chữ ký
      proxy.model.CompanyChiefAccountantTitle =
        !dbOptions.value.PrintTitleAccordingCircularTemplate ||
        (dbOptions.value.CompanyChiefAccountantTitle && dbOptions.value.CompanyChiefAccountantTitle != '')
          ? dbOptions.value.CompanyChiefAccountantTitle
          : 'Kế toán trưởng';

      proxy.model.CompanyDirectorTitle =
        !dbOptions.value.PrintTitleAccordingCircularTemplate ||
        (dbOptions.value.CompanyDirectorTitle && dbOptions.value.CompanyDirectorTitle != '')
          ? dbOptions.value.CompanyDirectorTitle
          : 'Thủ trưởng đơn vị';
      proxy.model.CompanyChiefAccountant = dbOptions.value.PrintPersonNameInReport
        ? dbOptions.value.CompanyChiefAccountant
        : '';
      proxy.model.CompanyDirector = dbOptions.value.PrintPersonNameInReport ? dbOptions.value.CompanyDirector : '';

      //Xử lý dữ liệu theo tham số
      getReportData(data, dataParam);
    }

    /**
     * Xử lý dữ liệu in báo cáo
     */
    function getReportData(data, dataParam) {
      let me = proxy;
      let dataReport = [];
      // Xét sort_order cho định khoản
      let dataParallels =
        data?.Parallels && data?.Parallels.length > 0
          ? data.Parallels.map((x, index) => {
              return {
                debit_account: x.debit_account,
                credit_account: x.credit_account,
                amount: x.amount,
                amount_oc: x.amount_oc,
                accounting_object_name: x.accounting_object_name,
                accounting_object_address: x.accounting_object_address,
                sort_order: x.sort_order,
                description: x.description,
                temp_sort: index,
                alternate_sort: 1,
                isParallel: true,
              };
            })
          : [];

      let dataDetails =
        data?.Detail && data?.Detail.length > 0
          ? data?.Detail.map((x, index) => {
              return {
                debit_account: x.debit_account,
                credit_account: x.credit_account,
                amount: x.amount,
                amount_oc: x.amount_oc,
                accounting_object_name: x.accounting_object_name,
                accounting_object_address: x.accounting_object_address,
                sort_order: x.sort_order,
                description: x.description,
                temp_sort: index,
                alternate_sort: 0,
                isParallel: false,
              };
            })
          : [];

      if (dataParam.displayAccountNumberType == 0) {
        dataReport = dataParallels.length > 0 ? dataParallels : [];
      } else if (dataParam.displayAccountNumberType == 1) {
        dataReport = dataDetails.length > 0 ? dataDetails : [];
      } else {
        dataReport = [
          ...(dataDetails.length > 0 ? dataDetails : []),
          ...(dataParallels.length > 0 ? dataParallels : []),
        ];
      }

      let totalAmount = 0;
      if (dataReport && dataReport.length > 0) {
        //Loại bỏ các dòng số tiền = 0
        dataReport = dataReport.filter(x => x.amount > 0);
        // Check điều kiện form tham số
        if (dataParam.isSummarySameInfo) {
          // nếu tích chọn Cộng gộp các bút toán giống nhau
          let grDataDetail = commonFunction.getGroupByFuncKey(dataReport, x => ({
            debit_account: x.debit_account,
            credit_account: x.credit_account,
          }));
          dataReport = Object.keys(grDataDetail)?.map((key, index) => {
            const sumGr = grDataDetail[key].reduce((pre, cur) => {
              cur['amount'] = cur['amount'] ?? 0;
              pre = pre ?? 0;
              return pre + cur['amount'];
            }, 0);
            totalAmount += dataParam.displayAccountNumberType == 0 || dataParam.displayAccountNumberType == 1 || (dataParam.displayAccountNumberType == 2 && dataParam.isAddAmountSingle) ? sumGr : grDataDetail[key][0]?.isParallel ? 0 : sumGr;
            let item = {
              // line: index + 1,
              description: data.journal_memo,
              debit_account: grDataDetail[key][0]?.debit_account,
              credit_account: grDataDetail[key][0]?.credit_account,
              amount: formatAmount(sumGr),
              temp_sort: grDataDetail[key][0]?.temp_sort,
              alternate_sort: grDataDetail[key][0]?.alternate_sort,
            };
            return item;
          });
        } else {
          dataReport = dataReport?.map((x, index) => {
            totalAmount += dataParam.displayAccountNumberType == 0 || dataParam.displayAccountNumberType == 1 || (dataParam.displayAccountNumberType == 2 && dataParam.isAddAmountSingle) ? x.amount : x.isParallel ? 0 : x.amount;
            let item = {
              // line: index + 1,
              description: x.description,
              debit_account: x.debit_account,
              credit_account: x.credit_account,
              amount: formatAmount(x.amount),
              temp_sort: x.temp_sort,
              alternate_sort: x.alternate_sort,
            };
            return item;
          });
        }

        //Sắp xếp các định khoản theo tham số
        if (dataParam.isAlternateSort) {
          dataReport = dataReport.sortObject('temp_sort', 'alternate_sort');
        } else {
          dataReport = dataReport.sortObject('alternate_sort', 'temp_sort');
        }

        //Trả kết quả
        proxy.model.dataDetail = dataReport.map((x, index) => {
          let item = {
            line: index + 1,
            description: x.description,
            debit_account: x.debit_account,
            credit_account: x.credit_account,
            amount: x.amount,
          };
          return item;
        });

        proxy.model.dataDetail.push({
          description: 'Cộng',
          amount: formatAmount(totalAmount),
        });
      }

      // Xử lý đọc tiền
      proxy.model.strTotalAmount = numberText(totalAmount);
      // emit ra component cha để

      proxy.$nextTick(() => {
        proxy.$nextTick(() => {
          let tr = proxy.$el.querySelectorAll('tr');
          let totalHeight = 145;
          let footerHeight = 196;
          tr.forEach(element => {
            let isLastRow = element.firstElementChild.textContent == '';
            totalHeight += element.getBoundingClientRect().height;
            if (totalHeight > 970) {
              element.classList.add('html2pdf__page-break');
              let elementchilds = element.querySelectorAll('td');
              if (elementchilds.length > 0) {
                elementchilds.forEach((child, index) => {
                  child.style.borderBottom = '1px solid';
                  if (isLastRow) {
                    child.style.fontWeight = 700;
                    child.style.fontSize = '14px';
                    // if (index == 1){
                      child.style.textAlign = 'center';
                      child.style.alignItems = 'center';
                    // } 
                  }
                });
              }

              if (!isLastRow) {
                let trHeader = document.createElement('tr');
                trHeader.style.height = '34px';
                trHeader.innerHTML = `<tr>
                <td style="border: 1px solid; border-right: none; width: 50px; text-align: center; font-weight: 700">STT</td>
                <td style="border: 1px solid; border-right: none; text-align: center; font-weight: 700">Diễn giải</td>
                <td style="border: 1px solid; border-right: none; width: 75px; text-align: center; font-weight: 700">Ghi nợ</td>
                <td style="border: 1px solid; border-right: none; width: 75px; text-align: center; font-weight: 700">Ghi có</td>
                <td style="border: 1px solid; width: 100px; text-align: center; font-weight: 700">Thành tiền</td>
              </tr>`;
                element.parentNode.insertBefore(trHeader, element.nextElementSibling);
                let trEmpty = document.createElement('tr');
                trEmpty.style.height = '50px';
                element.parentNode.insertBefore(trEmpty, element.nextElementSibling);
              } else {
                let childs = element.previousSibling.querySelectorAll('td');
                if (childs.length > 0) {
                  childs.forEach((child, index) => {
                    child.style.borderBottom = '1px solid';
                  });
                }
                let trEmpty = document.createElement('div');
                trEmpty.style.height = '50px';
                element.parentNode.insertBefore(trEmpty, element.nextElementSibling);
              }

              totalHeight = 0;
            } else {
              if (isLastRow) {
                totalHeight += footerHeight;
                if (totalHeight > 970) {
                  let elementFooter = proxy.$el.querySelector('.footer-containx');
                  if (elementFooter) {
                    elementFooter.classList.add('html2pdf__page-break');

                    let rowEmpty = document.createElement('div');
                    rowEmpty.style.height = '25px';
                    elementFooter.parentNode.insertBefore(rowEmpty, elementFooter.nextElementSibling);
                  }
                }
              }
            }
          });
        proxy.$emit('generatePDF', true);
        });
      });
    }

    /**
     * Format tiền
     */
    const formatAmount = amount => {
      return proxy.$ms.format.formatAmount(amount || 0, {
        optionFormat: proxy.$ms.constant.OptionFormat.ZeroToEmpty,
      });
    };

    return {
      proxy,
      model,
      dbOptions,
      columnsReport,
      numberText,
      roundValue,
      genUnits,
      genDigits,
      readTwo,
      readTwo,
    };
  },
};
</script>

<style lang="scss" scoped>
.report-accountant-voucher-offline {
  .ms-grid-viewer:deep {
    font-size: 13px;
    padding: 8px 0 !important;
    .ms-col-td {
      border-left: 1px solid !important;
      border-right: none !important;
    }
    .ms-thead {
      .ms-th {
        background: #ffffff !important;
        border-bottom: 1px solid !important;
        border-top: 1px solid !important;

        .fs-small {
          font-size: 14px !important;
        }
      }
      .ms-col-th {
        border-left: 1px solid !important;
        border-right: none !important;
        height: 27px;
        .ms-th-content {
          .fs-big {
            font-size: 13px !important;
            margin: 3px 0px !important;
          }
        }
      }
      .ms-col-th-last {
        border-right: 1px solid !important;
      }
      .ms-th-title {
        .text-left {
          text-align: center !important;
        }
      }
    }
    .ms-tbody {
      tr:last-child {
        td:nth-child(2) {
          .text-left {
            text-align: center !important;
            font-weight: 700 !important;
            font-size: 14px;
          }
        }

        td:last-child {
          .text-left {
            text-align: right !important;
            font-weight: 700 !important;
          }
        }
      }

      tr td:first-child {
        .text-left {
          text-align: center !important;
        }
      }
    }

    .row-selected td {
      background-color: #ffffff !important;
    }
    .ms-content--table {
      .ms-tr {
        height: 34px;
        .ms-col-td-last {
          border-right: 1px solid !important;
          .text-left {
            text-align: right;
          }
        }
      }
      .ms-td {
        border-bottom: 1px dotted;

        .ms-td-normal-span {
          font-size: 13px;
          // min-height: none;
        }
      }

      tr:nth-last-child(-n + 2) {
        .ms-td {
          border-bottom: 1px solid;
        }
      }
    }
  }

  .container-accountant-voucher {
    width: 100%;
    padding: 50px;
    background-color: #fff !important;
    font-family: 'Times New Roman', Times, serif;

    .header-contain {
      .header-title {
        display: flex;
        width: 100%;
        font-weight: 700;
        font-size: 22px;
        padding: 20px;
        justify-content: center;
      }
      .header-info {
        font-size: 14px;
      }
      .header-info-value {
        padding-left: 4px;
      }
    }

    .body-contain {
      font-size: 14px;
      width: 100%;

      .body-content-row {
        display: flex;
        margin: 4px 0;
        width: 100%;

        .w-bigger {
          width: 70%;
        }
        .w-smaller {
          width: 30%;
        }

        .content-value {
          padding-left: 4px;
        }
      }
    }

    .footer-contain {
      width: 100%;
      display: flex;
      justify-content: center;
      .footer-block {
        width: 70%;
        display: flex;
        margin-top: 25px;
        justify-content: space-between;
      }

      .footer-col {
        display: flex;
        flex-direction: column;
        justify-content: center;

        .sign-label {
          display: flex;
          flex-direction: column;
          justify-content: center;
          margin-bottom: 100px;

          .sign-name {
            width: 100%;
            font-size: 16px;
            font-weight: 700;
            display: flex;
            justify-content: center;
          }

          .sign-sub {
            width: 100%;
            font-style: italic;
            display: flex;
            justify-content: center;
          }
        }
        .sign-value {
          font-weight: 700;
          width: 100%;
          font-size: 14px;
          display: flex;
          justify-content: center;
        }
      }
    }
  }
}
</style>
